let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i05W6")).then(() => parcelRequire('ksxpk'));